module.exports = __webpack_public_path__ + "img/product-shot_03.18cd25f4.jpg";